export default "__VITE_ASSET__C0yN$w1$__"